module.exports = __webpack_public_path__ + "ni.59cafd57897dba393d45.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ni.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ni.svg
// module chunks = styles